
import { Link } from 'react-router-dom';
import { Leaf } from 'lucide-react';
import { useSiteSettings } from '@/hooks/useSiteSettings';
import { Skeleton } from '@/components/ui/skeleton';

interface LogoProps {
  onLogoClick?: () => void;
}

const Logo = ({ onLogoClick }: LogoProps) => {
  const { data: settings, isLoading } = useSiteSettings();

  const renderLogo = () => {
    if (isLoading) {
      return <Skeleton className="h-8 w-32" />;
    }
    
    // Use custom logo from settings, or default to uploaded logo
    const logoUrl = settings?.logo_image_url || '/logo.png';
    const logoHeight = settings?.logo_height || 32;
    
    return (
      <img
        src={logoUrl}
        alt="Paudhify"
        className="object-contain"
        width={Math.round(logoHeight * 1.9)}
        height={logoHeight}
        style={{ height: `${logoHeight}px` }}
      />
    );
  };

  return (
    <Link to="/" onClick={onLogoClick} className="flex items-center gap-2 hover:opacity-80 transition-opacity">
      {renderLogo()}
    </Link>
  );
};

export default Logo;

